module.exports = __webpack_public_path__ + "img/dana.43dfe561.webp";